import { GET_SUBCATEGORY, GET_SUBCATEGORY_BY_ID } from "../constants/index";

export const subcategory = (
  state = { subcategorylist: [], subcategorybyid: {} },
  action,
) => {
  switch (action.type) {
    case GET_SUBCATEGORY:
      return { ...state, subcategorylist: action.subcategorylist };
    case GET_SUBCATEGORY_BY_ID:
      return { ...state, subcategorybyid: action.subcategorybyid };
    default:
      return state;
  }
};
